// This module handles MAP price loading and collection data fetching

(function() {
  'use strict';

  // Initialize global MAP prices object
  window.PB_MAP_PRICES = {};

  async function fetchCollectionAllPages(collection) {
    let page = 1;
    let totalProductsLoaded = 0;
    const MAX_PAGES = 20; // Safety limit to prevent infinite loops

    while (page <= MAX_PAGES) {
      try {
        const url = `/pages/${collection.handle}${page > 1 ? '?page=' + page : ''}`;

        const response = await fetch(url);
        if (!response.ok) {
          console.warn(`  ${collection.name} page ${page}: HTTP ${response.status}`);
          break;
        }

        const html = await response.text();

        // Parse HTML
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        // Execute script tags
        const scripts = doc.querySelectorAll('script');
        const beforeCount = Object.keys(window.PB_MAP_PRICES).length;
        let scriptExecuted = false;

        for (let script of scripts) {
          const content = script.textContent || '';
          // Look for our specific MAP prices loading code that has actual product data
         
          if (content.includes('window.PB_MAP_PRICES') && content.includes('PB_MAP_PRICES["')) {
            try {
              eval(content);
              scriptExecuted = true;
              break;
            } catch (error) {
              console.error(` ${collection.name} page ${page} script error:`, error);
            }
          }
        }

        const afterCount = Object.keys(window.PB_MAP_PRICES).length;
        const addedCount = afterCount - beforeCount;

        if (!scriptExecuted) {
          // No more pages with actual product data - this is the normal end condition
          break;
        }

        // Continue fetching even if addedCount is 0 for this page
        // (products might have been added by another parallel collection)
        // The scriptExecuted check above ensures we stop when no more product data exists
        totalProductsLoaded += addedCount;
        page++;

      } catch (error) {
        console.error(` ${collection.name} page ${page} error:`, error);
        break;
      }
    }

    return totalProductsLoaded;
  }

  window.PB_loadMAPPrices = async function() {
    try {
      // Use collections from config
      const collections = window.PB_MAP_COLLECTIONS || [];

      // Fetch all collections at the same time (parallel)
      const results = await Promise.all(
        collections.map(collection => fetchCollectionAllPages(collection))
      );

      return true;
    } catch (error) {
      console.error('Failed to load MAP prices:', error);
      window.PB_MAP_PRICES = {};
      return false;
    }
  };

  
  // Load all collections in PARALLEL for faster loading
  window.PB_MAP_PRICES_LOADED = window.PB_loadMAPPrices();

  window.PB_PREDEFINED_FILTERS = {
    sizes: {
      'ranges': ['24 Inch', '30 Inch', '36 Inch', '48 Inch', '60 Inch'],
      'rangetops': ['24 Inch', '30 Inch', '36 Inch', '48 Inch'],
      'refrigerators': ['30 Inch', '36 Inch', '60 Inch', '72 Inch'],
      'column-refrigerators': ['18 Inch', '24 Inch', '30 Inch'],
      'hoods': ['20.5 Inch', '24 Inch', '28 Inch', '30 Inch', '34 Inch', '36 Inch', '40 Inch', '42 Inch', '46 Inch', '48 Inch', '52 Inch', '54 Inch', '58 Inch', '60 Inch', '72 Inch'],
      'dishwashers': ['18 Inch', '24 Inch'],
      'microwaves': ['24 Inch', '30 Inch'],
      'wall-ovens': ['30 Inch'],
      'under-counter-refrigeration': ['15 Inch', '24 Inch']
    },
    finishes: {
      'ranges': ['Stainless Steel', 'Satin Stainless Steel', 'Black Stainless Steel', 'Black Satin Stainless Steel'],
      'rangetops': ['Stainless Steel', 'Satin Stainless Steel', 'Black Stainless Steel', 'Black Satin Stainless Steel'],
      'refrigerators': ['Stainless Steel', 'Satin Stainless Steel', 'Black Stainless Steel', 'White Matte', 'Panel Ready'],
      'column-refrigerators': ['Stainless Steel', 'Satin Stainless Steel', 'Black Stainless Steel', 'White Matte'],
      'hoods': ['Black Stainless Steel', 'Stainless Steel', 'Satin Stainless Steel', 'Unfinished Wood', 'Wood', 'Oil Rubbed Bronze', 'White Matte', 'Black Matte', 'Copper', 'Blue Gloss', 'Red Gloss', 'Blue Matte', 'Red Matte', 'Cottage White', 'Rustic Black', 'Rustic Shiplap Bright White', 'Rustic Shiplap Black', 'Rustic Bright White'],
      'dishwashers': ['Stainless Steel', 'Satin Stainless Steel', 'Black Stainless Steel', 'Hand-Hammered Copper', 'Unfinished Wood', 'Oil-Rubbed Bronze', 'White Matte', 'Copper'],
      'microwaves': ['Stainless Steel', 'Satin Stainless Steel', 'Black Stainless Steel'],
      'wall-ovens': ['Stainless Steel', 'Satin Stainless Steel', 'Black Stainless Steel', 'White Matte Door'],
      'under-counter-refrigeration': ['Stainless Steel', 'Black Stainless Steel', 'White Matte', 'Black Matte', 'Satin Stainless Steel'],
      'plumbing': ['Brushed Nickel', 'Chrome', 'Gun Metal', 'Oil Rubbed Bronze', 'Polished Gold', 'Champagne Bronze', 'Matte Black', 'Stainless Steel', 'Satin Stainless Steel']
    },
    accents: {
      'ranges': ['Polished Gold Accents', 'Champagne Bronze Accents', 'Matte Black Accents'],
      'rangetops': ['Polished Gold Accents', 'Champagne Bronze Accents', 'Matte Black Accents'],
      'hoods': ['Polished Gold Accents', 'Champagne Bronze Accents', 'Matte Black Accents'],
      'refrigerators': ['Polished Gold Accents', 'Champagne Bronze Accents', 'Matte Black Accents'],
      'column-refrigerators': ['Polished Gold Accents', 'Champagne Bronze Accents', 'Matte Black Accents', 'Polished Nickel Accents'],
      'microwaves': ['Polished Gold Accents', 'Champagne Bronze Accents', 'Matte Black Accents'],
      'wall-ovens': ['Polished Gold Accents', 'Champagne Bronze Accents', 'Matte Black Accents'],
      'dishwashers': ['Polished Gold Accents', 'Champagne Bronze Accents', 'Matte Black Accents'],
      'under-counter-refrigeration': ['Champagne Bronze Accents', 'Matte Black Accents', 'Polished Gold Accents']
    },
    fuelTypes: {
      'ranges': ['Dual Fuel', 'All Gas', 'Induction']
    },
    handleTypes: {
      'ranges': ['Classic Handle', 'Standard Handle', 'Helix Handle'],
      'dishwashers': ['Traditional Handle', 'Modern Handle', 'Helix Handle'],
      'refrigerators': ['Modern Handle', 'Traditional Handle', 'Square Handle', 'Helix Handle'],
      'column-refrigerators': ['Traditional Handle', 'Helix Handle'],
      'wall-ovens': ['Traditional Handle', 'Helix Handle'],
      'microwaves': ['Traditional Handle', 'Modern Handle', 'Helix Handle']
    },
    mountTypes: {
      'hoods': ['Wall Mount', 'Island Mount', 'Under Cabinet', 'Insert']
    },
    refrigeratorTypes: {
      'refrigerators': ['Counter Depth', 'Standard Depth', 'Built In Refrigeration']
    },
    columnRefrigeratorTypes: {
      'column-refrigerators': ['Column Refrigeration', 'Column Freezer', 'Column Wine']
    },
    interiorFinishes: {
      'refrigerators': ['Graphite Gray Interior', 'Stainless Steel Interior', 'Bright White Interior']
    },
    doorTypes: {
      'refrigerators': ['French Door', 'Single Door']
    },
    microwaveTypes: {
      'microwaves': ['Built In Microwave Oven', 'Built In Microwave Drawer', 'Over The Range Microwave']
    },
    rangetopTypes: {
      'rangetops': ['Range Top', 'Drop In']
    },
    underCounterTypes: {
      'under-counter-refrigeration': ['Wine Refrigeration', 'Beverage Fridge', 'Refrigerator Drawer', 'Ice Maker']
    },
    numberOfOvens: {
      'wall-ovens': ['Single Oven', 'Double Oven']
    },
    panelTypes: {
      'dishwashers': ['Panel Included', 'Panel Ready', 'Dishwasher Panels'],
      'column-refrigerators': ['Panel Ready', 'Panel Included']
    },
    plumbingTypes: {
      'plumbing': ['Kitchen Plumbing', 'Bathroom Plumbing']
    },
    plumbingSubTypes: {
      'Kitchen Plumbing': ['Kitchen Faucet', 'Kitchen Sink', 'Pot Filler'],
      'Bathroom Plumbing': ['Bathroom Faucet', 'Shower System', 'Tub Filler']
    },
    plumbingFinishesByProductType: {
      'Kitchen Faucet': ['Polished Gold', 'Matte Black', 'Chrome', 'Gun Metal', 'Brushed Nickel', 'Champagne Bronze'],
      'Kitchen Sink': ['Stainless Steel', 'Satin Stainless Steel'],
      'Pot Filler': ['Brushed Nickel', 'Chrome', 'Matte Black', 'Oil Rubbed Bronze', 'Polished Gold', 'Champagne Bronze'],
      'Bathroom Faucet': ['Polished Gold', 'Champagne Bronze', 'Matte Black', 'Chrome', 'Brushed Nickel'],
      'Shower System': ['Matte Black', 'Champagne Bronze', 'Chrome', 'Brushed Nickel', 'Polished Gold'],
      'Tub Filler': ['Champagne Bronze', 'Chrome', 'Polished Gold', 'Brushed Nickel', 'Matte Black']
    }
  };

  function createFilterOptions(values) {
    if (!values) return [];
    return values.map(name => ({
      id: name.hashCode ? name.hashCode() : name.split('').reduce((h, c) => ((h << 5) - h) + c.charCodeAt(0), 0),
      name: name
    }));
  }

  window.PB_loadCollectionOptions = async function(collection, state) {
    try {
      let allProducts = [];
      let page = 1;
      const limit = 250; // Shopify's maximum limit per page
      let hasMoreProducts = true;

      // Load all pages of products
      while (hasMoreProducts) {
        const url = `/collections/${collection.handle}/products.json?limit=${limit}&page=${page}`;
        const response = await fetch(url);

        if (!response.ok) {
          throw new Error(`HTTP ${response.status}: ${response.statusText}`);
        }

        const data = await response.json();

        if (data.products && data.products.length > 0) {
          allProducts = allProducts.concat(data.products);

          // If we got fewer products than the limit, we've reached the end
          if (data.products.length < limit) {
            hasMoreProducts = false;
          } else {
            page++;
          }
        } else {
          hasMoreProducts = false;
        }
      }

      // Filter out products with "kitchen packages" tag
      const filteredProducts = allProducts.filter(product => {
        if (!product.tags) return true;
        return !product.tags.some(tag => {
          const lowerTag = tag.toLowerCase();
          return lowerTag === 'kitchen packages' || lowerTag.includes('kitchen packages');
        });
      });

      const filters = window.PB_PREDEFINED_FILTERS;

      // For Promo 2 collection, use the actual product type as className
      const className = (collection.id === 'promo-2' && filteredProducts.length > 0)
        ? (filteredProducts[0].product_type || collection.name)
        : collection.name;

      state.filterOptions[collection.id] = {
        classId: collection.id,
        className: className,
        sizes: filters.sizes[collection.id] || [],
        finishes: createFilterOptions(filters.finishes[collection.id]),
        accentFinishes: createFilterOptions(filters.accents[collection.id]),
        helixOptions: [],
        fuelTypes: createFilterOptions(filters.fuelTypes[collection.id]),
        handleTypes: createFilterOptions(filters.handleTypes[collection.id]),
        mountTypes: createFilterOptions(filters.mountTypes[collection.id]),
        refrigeratorTypes: createFilterOptions(filters.refrigeratorTypes[collection.id]),
        columnRefrigeratorTypes: createFilterOptions(filters.columnRefrigeratorTypes[collection.id]),
        microwaveTypes: createFilterOptions(filters.microwaveTypes[collection.id]),
        rangetopTypes: createFilterOptions(filters.rangetopTypes[collection.id]),
        underCounterTypes: createFilterOptions(filters.underCounterTypes[collection.id]),
        panelTypes: createFilterOptions(filters.panelTypes[collection.id]),
        numberOfOvens: createFilterOptions(filters.numberOfOvens[collection.id]),
        interiorFinishes: createFilterOptions(filters.interiorFinishes[collection.id]),
        doorTypes: createFilterOptions(filters.doorTypes[collection.id]),
        plumbingTypes: createFilterOptions(filters.plumbingTypes[collection.id]),
        plumbingSubTypes: filters.plumbingSubTypes || {},
        plumbingFinishesByProductType: filters.plumbingFinishesByProductType || {},
        allProducts: filteredProducts
      };

    } catch (error) {
      console.error(`Error loading ${collection.name}:`, error);
    }
  };

  console.log('Package Builder Data loaded');
})();
